import React, { useEffect, useRef, useState } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import { CKEditor } from "ckeditor4-react";
import swal from 'sweetalert';

import { getSenderEmail, postBulkMail, sendEmail } from '../../actions/auth';
import AdminHeader from '../layout/AdminHeader';
import TextValidator from '../partial/TextValidator';
import SelectValidator from '../partial/SelectValidator';
import { selectValueGetter } from '../../utils/helper';

function SendGrid() {
      const [activeMode, setActiveMode] = useState("custom");
        const ckEditorRef = useRef(null);
  const [customHTML, setCustomHTML] = useState("");
  const [showPreview, setShowPreview] = useState(false);
    const [loader, setLoader] = useState(false);
    const [selectedEmail ,setSelectedEmail] = useState()
    const userID = localStorage.getItem("userId")
    const [datas, setDatas] = useState();
    const [editorData, setEditorData] = useState("");
    const [data, setData] = useState();
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({

        id: 0,
        campaignName: "",
        subject: "",
        fromName: "",
        fromEmail: "",
        createdAt: "",
        totalEmail: 0,
        totalSend: 0,
        totalPending: 0,
        totalFail: 0,
        requestId: "",
        userId: userID,
        body: "",
        emails: []

    });
  const handleTabSwitch = (mode) => {
    setActiveMode(mode);
    setShowPreview(false);
  };
    const { subject, fromEmail, fromName, campaignName } = formData;
    console.log(formData)

    const fetchExams = async () => {
        setLoader(true);
        try {
            const res = await getSenderEmail(userID);
            console.log(res);
            const options = res.data
                .filter(item => item.status === "Success")
                .map(item => ({
                    label: item.fromEmail,
                    value: item.fromEmail,
                }));
            
            setLoader(false);
            setDatas(options);
    
        } catch (error) {
            setLoader(false);
        }
    };
    

    useEffect(() => {
        fetchExams();
    }, []);
    console.log(datas)
 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!file) {
    setState({
      ...state,
      error: true,
      errorMsg: "Please upload a file",
    });
    return;
  }

  try {
    setLoader(true);

    const res = await postBulkMail(formData);

    if (res.message === "Sucess") {
      swal({
        icon: "success",
        title: res?.message,
        timer: 3000,
      });

      setFormData({
        id: 0,
        campaignName: "",
        subject: "",
        fromName: "",
        fromEmail: "",
        createdAt: "",
        totalEmail: 0,
        totalSend: 0,
        totalPending: 0,
        totalFail: 0,
        requestId: "",
        userId: userID,
        body: "",
        emails: [],
      });

      setCustomHTML("");
      setEditorData("");
      setSelectedEmail(null);
    } else {
      swal({
        icon: "error",
        title: res?.message,
      });
    }
  } catch (error) {
    swal({
      icon: "error",
      title: "Something went wrong",
    });
  } finally {
    setLoader(false);
  }
};

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

 const handleFile = (event) => {
  const selectedFile = event.target.files[0];

  if (!selectedFile) return;

  setState({
    file: selectedFile,
    error: false,
    errorMsg: "",
  });

  const reader = new FileReader();

  reader.onload = (e) => {
    const content = e.target.result;
    const lines = content.split("\n").filter((line) => line.trim() !== "");

    const headers = lines[0].split(",").map((h) => h.trim());

    const data = lines.slice(1).map((line) => {
      const values = line.split(",").map((v) => v.trim());
      let record = {};
      headers.forEach((header, index) => {
        record[header] = values[index];
      });
      return record;
    });

    setFormData((prev) => ({
      ...prev,
      emails: data,
    }));
  };

  reader.readAsText(selectedFile);
};

    const handleEmailChange = (selectedExam) => {
        setSelectedEmail(selectedExam.value);
        setFormData((prevFormData) => ({
          ...prevFormData,
          fromEmail: selectedExam.value, 
        }));
      };
    const [state, setState] = useState({
        file: "",
        error: true,
        errorMsg: "Note:- Only .csv type files are supported.",
    });

    const { file, error, errorMsg } = state;

    // const handleEditorChange = (event) => {
    //     const data = event.editor.getData();
    //     setEditorData(data);
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         body: data
    //     }));
    // };

  const handleEditorChange = (value, type = "custom") => {
  if (type === "editor") {
    const data = value.editor.getData();
    setEditorData(data);
    setFormData((prev) => ({
      ...prev,
      body: data,
    }));
  } else {
    setCustomHTML(value);
    setFormData((prev) => ({
      ...prev,
      body: value,
    }));
  }
};

    return (
        <div>
            <AdminHeader name={"Send Email"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className='dashboard__content'>
                <div className="dashboard__transactionsCard">
                    <div className="dashboard__header">
                        <div className="dashboard__left">
                            <h4 id='transction_list'>Send Email</h4>
                        </div>
                    </div>
                    <ValidatorForm className="dashboard__customerViewMain" onSubmit={(e) => handleSubmit(e)}>
                        <div className='dashboard__customerViewCard'>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group withIcon">
                                        <label>Purpose</label>
                                        <TextValidator
                                            placeholder="Purpose"
                                            className="form-control"
                                            name="campaignName"
                                            value={campaignName}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["Please enter purpose"]}

                                        />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group withIcon">
                                        <label>Subject</label>
                                        <TextValidator
                                            placeholder="Subject"
                                            className="form-control"
                                            name="subject"
                                            value={subject}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["Please enter subject"]}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group withIcon">
                                        <label>From Name</label>
                                        <TextValidator placeholder="From Name" className="form-control" name="fromName" onChange={handleChange} value={fromName}
                                            validators={["required"]}
                                            errorMessages={["Please enter from name"]} />
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group withIcon">
                                        <label>From Email</label>
                                        <SelectValidator
                                        onChange={handleEmailChange}
                                        menuPortalTarget={document.body}
                                        options={datas}
                                        validators={["required"]} errorMessages={[" Email is required."]}
                                        value={selectValueGetter(datas, selectedEmail)}
                                    />
    

                                    </div>
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <div className="form-group withIcon">
                                        <label>Email Data</label>
                                        <div encType="multipart/form-data">
                                            <input className="form-control" placeholder="Uploaded File" type="file" accept=".csv" required onChange={handleFile} />
                                            {error && <span style={{ color: "red" }}>{errorMsg}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                          <div>
                  <div style={{ marginBottom: "1rem" }}>
                    <button
                      type="button"
                      onClick={() => handleTabSwitch("custom")}
                      style={{
                        marginRight: "10px",
                        backgroundColor: activeMode === "custom" ? "#007bff" : "#ccc",
                        color: "white",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Custom Code
                    </button>

                    <button
                      type="button"
                      onClick={() => handleTabSwitch("editor")}
                      style={{
                        backgroundColor: activeMode === "editor" ? "#007bff" : "#ccc",
                        color: "white",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Editor
                    </button>
                  </div>

                  <div className="col-xl-12">
                    {activeMode === "custom" && (
                      <div>
                        <b>Enter your HTML Code</b>
                        {!showPreview ? (
                          <>
                            <textarea
                              value={customHTML}
                            onChange={(e) => handleEditorChange(e.target.value, "custom")}
                              rows={10}
                              style={{
                                width: "100%",
                                padding: "10px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                fontFamily: "monospace",
                              }}
                            />
                            <div style={{ marginTop: "10px" }}>
                              <button
                                type="button"
                                onClick={() => setShowPreview(true)}
                                style={{
                                  backgroundColor: "#28a745",
                                  color: "white",
                                  border: "none",
                                  padding: "8px 16px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                Preview
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                padding: "10px",
                                background: "#fff",
                              }}
                              dangerouslySetInnerHTML={{ __html: customHTML }}
                            />
                            <div style={{ marginTop: "10px" }}>
                              <button
                                type="button"
                                onClick={() => setShowPreview(false)}
                                style={{
                                  backgroundColor: "#6c757d",
                                  color: "white",
                                  border: "none",
                                  padding: "8px 16px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                Back to Edit
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {activeMode === "editor" && (
                      <div>
                        <CKEditor
                          ref={ckEditorRef}
                          config={{ versionCheck: false }}
                          data={editorData}
                          onChange={(e) => handleEditorChange(e, "editor")}
                          name="Body"
                        />
                      </div>
                    )}
                  </div>
                </div>
                            <div className='customer_group_form'>
                                <button type='submit' style={{ marginTop: "10px" }} className="btn btn-primary btn-lg">
                                    Send
                                </button>
                            </div>
                        </div>
                    </ValidatorForm>
                </div>
            </div>
        </div>
    );
}

export default SendGrid;
